import { ReactNode, useCallback, useMemo } from "react";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AxiosError } from "axios";
import useAuth from "../hooks/useAuth";
import useAlert from "../hooks/useAlert";

export default function QueryProvider({ children }: { children: ReactNode }) {
  const { onLogout } = useAuth();
  const alert = useAlert();

  const handleQueryError = useCallback(
    ({ request, response }: AxiosError<any>) => {
      let msg: string = response?.data?.message || "خطأ";
      if (request.status === 401) {
        onLogout();
        msg = "الرجاء تسجيل الدخول";
      } else if (request.status === 0) msg = "غير متصل بالانترنت";
      alert({ title: msg });
    },
    [onLogout, alert]
  );

  const handleMutationError = useCallback(
    (error: AxiosError<any>) => {
      const errors = error.response?.data?.errors;
      if (typeof errors !== "object") return handleQueryError(error);

      Object.values(errors).forEach((_error: any) => {
        alert({ title: Array.isArray(_error) ? _error.join(", ") : _error });
      });
    },
    [handleQueryError, alert]
  );

  const queryClient = useMemo(() => {
    return new QueryClient({
      defaultOptions: {
        queries: {
          retry: false,
          // TODO: remove on production
          refetchOnWindowFocus: false,
        },
      },
      queryCache: new QueryCache({ onError: handleQueryError as any }),
      mutationCache: new MutationCache({ onError: handleMutationError as any }),
    });
  }, []); // eslint-disable-line

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
